import React from "react";
import uuidv4 from "uuid/v4";

import { useTranslation } from "react-i18next";

import CurrencyInput from "react-currency-input";

import { Row, Col } from "reactstrap";
import InputWithLabel from "components/FormControls/InputWithLabel";

export default function NonStandardAccomodationPriceDetail({ cpd, handleUpdateContractPriceDetail, isManager }) {
  const { t } = useTranslation();

  let guid1 = uuidv4();

  return (
    <Row>
      <Col md="12">
        <h5>{t("non_standard_room")}</h5>
        <div className="d-flex flex-nowrap">
          <div className="form-group pt-2 pb-2 pr-2">
            <label className="form-label" htmlFor={`value-${guid1}`}>
              {t("price")}
            </label>
            <div className="input-group mt-1">
              <div className="input-group-prepend">
                <span className="input-group-text">$</span>
              </div>
              <CurrencyInput
                value={cpd.nonStandard_Price}
                id={`value-${guid1}`}
                onBlur={(e) => handleUpdateContractPriceDetail(e, cpd, "nonStandard_Price", true)}
                className="form-control text-right"
                disabled={!isManager}
              />
            </div>
          </div>
          <div className="form-group p-2">
            <InputWithLabel
              disabled
              className={"mt-1"}
              labelText={t("capacity")}
              inputType="number"
              fieldToUpdate="nonStandard_Capacity"
              objectToUpdate={cpd}
              persistOnBlur
              updateAction={handleUpdateContractPriceDetail}
            />
          </div>

          <div className="form-group p-2">
            <InputWithLabel
              className={"mt-1"}
              labelText={t("minimum_person_number")}
              inputType="number"
              fieldToUpdate="nonStandard_MinimumNumberOfPeople"
              objectToUpdate={cpd}
              persistOnBlur
              updateAction={handleUpdateContractPriceDetail}
              disabled={!isManager}
            />
          </div>

          <div className="form-group p-2">
            <InputWithLabel
              className={"mt-1"}
              labelText={t("adult_number")}
              inputType="number"
              fieldToUpdate="nonStandard_NumberOfAdults"
              objectToUpdate={cpd}
              persistOnBlur
              updateAction={handleUpdateContractPriceDetail}
              disabled={!isManager}
            />
          </div>

          <div className="form-group p-2">
            <InputWithLabel
              className={"mt-1"}
              labelText={t("child_number")}
              inputType="number"
              fieldToUpdate="nonStandard_NumberOfChildren"
              objectToUpdate={cpd}
              persistOnBlur
              updateAction={handleUpdateContractPriceDetail}
              disabled={!isManager}
            />
          </div>
        </div>
        <div className="d-flex flex-nowrap">
          <div className="form-group p-2">
            <label className="form-label" htmlFor={`additionnal-price-child-${guid1}`}>
              {t("additionnal_price_child")}
            </label>
            <div className="input-group mt-1">
              <div className="input-group-prepend">
                <span className="input-group-text">$</span>
              </div>
              <CurrencyInput
                value={cpd.nonStandard_PricePerAdditionalChild}
                id={`additionnal-price-child-${guid1}`}
                onBlur={(e) => handleUpdateContractPriceDetail(e, cpd, "nonStandard_PricePerAdditionalChild", true)}
                className="form-control text-right"
                disabled={!isManager}
              />
            </div>
          </div>
          <div className="form-group p-2">
            <label className="form-label" htmlFor={`additionnal-price-adult-${guid1}`}>
              {t("additionnal_price_adult")}
            </label>
            <div className="input-group mt-1">
              <div className="input-group-prepend">
                <span className="input-group-text">$</span>
              </div>
              <CurrencyInput
                value={cpd.nonStandard_PricePerAdditionalAdult}
                id={`additionnal-price-adult-${guid1}`}
                onBlur={(e) => handleUpdateContractPriceDetail(e, cpd, "nonStandard_PricePerAdditionalAdult", true)}
                className="form-control text-right"
                disabled={!isManager}
              />
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
}
